import { Box, Flex, Heading, Image, Text } from "@chakra-ui/react";
import { GradientButton } from "src/components/GradientButton";
import { observer } from "mobx-react-lite";
import React from "react";
import {
  LuHeartHandshake,
  LuMessagesSquare,
  LuShieldCheck,
} from "react-icons/lu";
import { useBrand } from "brand/BrandConfig";
import { UnauthLayout } from "layouts/UnauthLayout";
import { useAuthStore } from "stores/AuthStoreProvider";

const POINTS = [
  {
    icon: LuMessagesSquare,
    text: "Pick a companion and talk about anything: your day, your plans, what's on your mind.",
  },
  {
    icon: LuHeartHandshake,
    text: "Companions are friendly and supportive. Chats stay respectful and safe for everyone.",
  },
  {
    icon: LuShieldCheck,
    text: "Companions are AI, not real people or therapists. In a crisis, call or text 988.",
  },
];

/**
 * First visit. RouteGuard sends users here until the core onboarding flag is
 * set. Note: the flag lives on the shared bible-core user, so a Lovelica
 * user who finished onboarding elsewhere skips this page.
 */
export const OnboardingPage = observer(() => {
  const brand = useBrand();
  const authStore = useAuthStore();
  const [isSaving, setIsSaving] = React.useState(false);
  const [failed, setFailed] = React.useState(false);

  async function start() {
    setIsSaving(true);
    setFailed(false);
    // RouteGuard moves the user on once the flag is set.
    const saved = await authStore.user?.setHasCompletedOnboarding(true);
    if (!saved) setFailed(true);
    setIsSaving(false);
  }

  return (
    <UnauthLayout>
      <Image src={brand.logo} alt={brand.name} width="120px" mx="auto" mb={6} />
      <Box color="white" width="100%">
        <Heading size="lg" textAlign="center" mb={6}>
          Welcome to {brand.name}
        </Heading>
        <Flex direction="column" gap={4} mb={8}>
          {POINTS.map(({ icon: Icon, text }) => (
            <Flex key={text} gap={3} align="flex-start">
              <Box color="accent" mt={0.5}>
                <Icon size={20} />
              </Box>
              <Text color="whiteAlpha.800">{text}</Text>
            </Flex>
          ))}
        </Flex>
        <GradientButton
          onClick={start}
          loading={isSaving}
          loadingText="One moment…"
        >
          Meet the companions
        </GradientButton>
        {failed && (
          <Text color="red.300" fontSize="sm" mt={3} textAlign="center">
            Couldn't save. Check your connection and try again.
          </Text>
        )}
      </Box>
    </UnauthLayout>
  );
});
